module.exports = __webpack_public_path__ + "blockquote.png";